module.exports = __webpack_public_path__ + "img/hacker-news-square.80dc9a6c.svg";